import { useSyncExternalStore } from 'react';
import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';

import {
  getApiLoadingCount,
  subscribeApiLoading,
} from 'utils/apiLoadingStore';

function useApiLoadingOpen() {
  const count = useSyncExternalStore(
    subscribeApiLoading,
    getApiLoadingCount,
    getApiLoadingCount
  );
  return count > 0;
}

const ApiLoadingOverlay = () => {
  const open = useApiLoadingOpen();

  return (
    <Backdrop
      open={open}
      sx={{
        zIndex: (theme) => theme.zIndex.modal + 10,
        flexDirection: 'column',
        gap: 2,
        color: '#fff',
      }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
        <CircularProgress color="inherit" size={48} />
      </Box>
    </Backdrop>
  );
};

export default ApiLoadingOverlay;
